import React, {PropsWithChildren} from 'react'

import {Block} from 'jsxstyle'

const ConfirmDialogContent: React.FC<PropsWithChildren> = ({children}) => {
  return (
    <Block
      textAlign="justify"
      color="#888888"
      whiteSpace="pre-line"
      fontSize="13px"
      lineHeight="18px"
      fontWeight={400}
      marginV="6px"
      padding="0 28px"
    >
      {children}
    </Block>
  )
}

export default ConfirmDialogContent
